import { fetchUserFiles } from '../api/digitalVault';
export default async (params = {}, artist, logger) => fetchUserFiles(params, `browse/audio/artist/${encodeURIComponent(artist)}`, logger);
